import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, AlertTitle } from '@mui/material';

interface Props {
  children: ReactNode;
  fallbackMessage?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

// AIDEV-NOTE: ErrorBoundary por card — isola falhas para nao derrubar o dashboard inteiro
export class DashboardErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[DashboardErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert severity="error" sx={{ m: 1 }}>
          <AlertTitle>Erro no componente</AlertTitle>
          {this.props.fallbackMessage || 'Ocorreu um erro ao renderizar este card.'}
        </Alert>
      );
    }

    return this.props.children;
  }
}
